import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

const initialState = {
  id: '',
  value: '',
};

export const getVerificationMonthData = createAsyncThunk(
  'stop/getVerificationMonthData',
  async (params) => {
    const { url, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(url, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    //console.log(data);
    return data === undefined ? null : data;
  }
);

const verificationMonthSlice = createSlice({
  name: 'stop/verificationMonth',
  initialState,
  reducers: {
    resetVerificationMonth: () => null,
  },
  extraReducers: {
    [getVerificationMonthData.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetVerificationMonth } = verificationMonthSlice.actions;

export default verificationMonthSlice.reducer;
